import React, { useState } from 'react';
import './PersonalDetails.css';
import FormsHeading from './FormsHeading';
import { buildHomePremiumPayload } from '../utils/premiumPayloads';

function PersonalDetails() {
    const [submitState, setSubmitState] = useState({ loading: false, message: '' });

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitState({ loading: true, message: 'Submitting...' });

        try {
            const formValues = Object.fromEntries(new FormData(event.currentTarget).entries());
            buildHomePremiumPayload(formValues);

            setSubmitState({ loading: false, message: 'Quote request submitted successfully.' });
            event.currentTarget.reset();
        } catch (error) {
            setSubmitState({ loading: false, message: 'Submission failed. Please try again.' });
        }
    };

  return (
        <div className='PersonalDetails'>
            <div>
                <FormsHeading text='Personal  Details' />
            </div>
            <div className='PersonalDetails_Forms'> 
                <form onSubmit={handleSubmit}> 
                    <div className='PersonalDetails_TopQuery'>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Fullname: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" name="fullName" placeholder="Please enter your fullname" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Phone: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="tel" name="phone" placeholder="Enter your contact here" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Email Address: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="email" name="email" placeholder="Enter your email number" required />
                        </div>
                    </div>
                    <FormsHeading text='Policy  Details' />
                    <div className='PersonalDetails_MiddleQuery'>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Effective Date: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="date" name="effectiveDate" placeholder="Enter Commencement Date" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Expiry Date: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="date" name="expiryDate" placeholder="Enter Expiration Date" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Cover Type: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" placeholder="Select Cover Type" required name="coverType" list="exampleCover"/>
                                <datalist id="exampleCover" style={{backgroundColor: 'green'}}>
                                    <option value="Comprehensive" />  
                                    <option value="Third-Party" />
                                    <option value="Third-Party Fire and Theft" /> 
                                    <option value="None" /> 
                                </datalist>
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Currency: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="text" placeholder="Select Currency" required name="currency" list="exampleList"/>
                                <datalist id="exampleList" style={{backgroundColor: 'green'}}>
                                    <option value="GMD" />  
                                    <option value="USD" />
                                    <option value="GHC" /> 
                                    <option value="GBP" /> 
                                </datalist>
                        </div>
                    </div>
                    <div className='PersonalDetails_TopQuery'>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Building: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="buildingValue" placeholder="Enter value of building" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Content: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="contentValue" placeholder="Enter value of content" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Public Liability: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="publicLiabilityValue" placeholder="Enter public liability amount" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Rent: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="rentValue" placeholder="Enter rent value" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Personal Accident: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="personalAccidentValue" placeholder="Enter personal accident value" required />
                        </div>
                        <div className='PersonalDetails_InputBox_Query'>
                            <label for="fname">Total Sum Insured: <span style={{color : 'red'}}>*</span></label><br/>
                            <input type="number" min="0" step="0.01" name="totalSumInsured" placeholder="0" required />
                        </div>
                    </div>
                    <div className="submitAction" >
                        <input className='FormSubmit' type="submit" value={submitState.loading ? 'SUBMITTING...' : 'SUBMIT'} disabled={submitState.loading} />
                    </div>
                    {submitState.message && <p className='FormSubmitMessage'>{submitState.message}</p>}
                </form>
            </div>
        </div>
    )
}

export default PersonalDetails;
